import { useCallback, useEffect, useState } from 'react';
export function useCopyToClipboard(value) {
    const [copied, setCopied] = useState(false);
    useEffect(() => {
        setCopied(false);
    }, [value]);
    const copy = useCallback(() => {
        const toCopy = typeof value === 'function' ? value() : value;
        if (toCopy) {
            navigator.clipboard
                .writeText(toCopy)
                .then(() => setCopied(true))
                .then(() => {
                setTimeout(() => {
                    setCopied(false);
                }, 2000);
            });
        }
    }, [value]);
    return {
        copied,
        copy,
        clipboardIsSupported: typeof navigator !== 'undefined' && navigator.clipboard?.writeText,
    };
}
